import React from 'react';
import { Helmet } from "react-helmet";

const HeadMeta = props => {
    const { page } = props;

    if(!page) return null;

    if(page.yoast) {
        let title = page.yoast.title;
        if(!title && page.title && page.title.rendered) title = page.title.rendered;
        if(!title && page.post_title) title = page.post_title;
        if(!title && page.acf.seo_title != null && page.acf.seo_title.length !== 0) title = page.acf.seo_title;

        let description = page.yoast.og_desc;
        if(description == null || description.length === 0) description = page.yoast.metadesc;
        if(!description && !page && page.acf.seo_description != null && page.acf.seo_description.length !== 0) description = page.acf.seo_description;


        let og_image = page.yoast.og_image;
        if(og_image == null || og_image.length === 0) og_image = null;
        if(!page && page.acf.seo_facebook_image != null && page.acf.seo_facebook_image.length !== 0) og_image = page.acf.seo_facebook_image.url;


        if(page.type === 'author') {
            title = nullToEmptyString(page.yoast.author_title) ? page.yoast.author_title : page.first_name+' '+page.last_name;
            if(nullToEmptyString(page.yoast.author_desc)) description = page.yoast.author_desc;
        }

        //console.log('Yoast meta', page.yoast);

        return (
            <Helmet> 

                <title itemProp="name" lang="nb-NO">{title}</title>
                <meta name="description" content={description} />

                <meta property="og:url" content={nullToEmptyString(page.link)} />
                <meta property="og:title" content={nullToEmptyString(title)} />
                <meta property="og:description" content={nullToEmptyString(description)} />
                <meta property="og:image" content={nullToEmptyString(og_image)} />

                <meta property="twitter:title" content={nullToEmptyString(title)} />
                <meta property="twitter:description" content={nullToEmptyString(description)} />

                <meta name="keywords" content={nullToEmptyString(page.yoast.focuskw)} />

            </Helmet>
        )
    } else {
        console.log('"Yoast" meta not available for this page/post');
        return null;
    }
}

const nullToEmptyString = str => {
    if(!str) return '';
    if(str === 'null') return '';

    return str;
}

export default HeadMeta;